module.exports = __webpack_public_path__ + "e4dd51f46566ed3ceacdc900bf2fdf01.png";